<template>
  <div class="import-header">
    <div class="header">
      <div class="title">{{ $t('popUp.createResume.title') }}</div>
    </div>
    <span>{{ $t('popUp.createResume.resumeTypeChoice') }}</span>
    <div class="import-header-buttons">
      <button class="main-button button-cancel" @click="$emit('setResumeType', 'FROM_SCRATCH')">
        {{ $t('popUp.createResume.resumeFromScratch') }}
      </button>
      <button class="main-button button-create" @click="$emit('setResumeType', 'IMPORT')">
        {{ $t('popUp.createResume.importResume') }}
      </button>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss">
@use '@/styles/colors.scss';

.import-header {
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
  .header {
    border-bottom: 1px solid colors.$light-blue-color;
    width: 100%;
    .title {
      padding-bottom: 0.5rem;
      color: colors.$light-blue-color;
      font-size: 16px;
      font-weight: bold;
      text-transform: uppercase;
    }
  }

  > span {
    font-size: 16px;
    line-height: 20px;
  }

  .import-header-buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1.7rem;
    margin-top: 16px;

    > button {
      white-space: nowrap;
      width: 13.5rem;
      margin-top: 0;
    }
  }
}
</style>
